import React from "react";
import "./style/Loading.css";

function Loading() {
  return <div className="loading"></div>;
}

export default Loading;
